export const _en = {
    seasons: {
        layer: {
            libelle: "Seasons"
        },
        buttons: {
            add: {
                label: "Add season"
            },
            del: {
                label: "Delete season"
            }
        },
        dialog: {
            creation: {
                title: "Add a new season"
            },
            edition: {
                title: "Add a new season"
            },
            deletion: {
                title: "Delete a season"
            }
        },
        deletedCheckBox: {
            label: "Display deleted data"
        }
    }
};

export const _fr = {
    seasons: {
        layer: {
            libelle: "Saisons"
        },
        buttons: {
            add: {
                label: "Saison"
            },
            del: {
                label: "Supprimer une saison"
            }
        },
        modal: {
            creation: {
                title: "Ajout d'une saison"
            },
            edition: {
                title: "Édition d'une saison"
            },
            deletion: {
                title: "Supprimer une saison"
            }
        },
        deletedCheckBox: {
            label: "Afficher les éléments archivés"
        }
    }
};